
import getRankColor from '../functions/getRankColor'
import NullAvatar from './NullAvatar';
import LabelPoint from './LabelPoints';
import CrownIcon from './CrownIcon';


export default function Podiumtutor({ props, rank, tutor, handleClick }) {
  let borderColor = getRankColor(rank);
  return (
    <div className="flex flex-column align-items-center relative w-full" onClick={() => handleClick(tutor?.publicId)}>
      <div className="ranking-tutor-item relative mb-5 w-full">
        {rank <= 3 &&
          <div class="crown-icon">
            <CrownIcon
              rank={rank}
              borderColor={borderColor}
            />
          </div>
        }
        <div className={`${rank > 3 ? 'px-5' : ''}`}>
          {rank > 3 &&
            <div class="tutor-badge-icon">
              <svg width={'100%'} viewBox="0 0 37 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 34V0H37V34L18 45.5L0 34Z" fill="#FFC69B" />
                <text
                  x="50%" y="45%"
                  text-anchor="middle"
                  font-size="18"
                  font-family="Arial, sans-serif"
                  fill="#FF611D"
                  font-weight="bold"
                  dominant-baseline="middle"
                >
                  {rank}
                </text>
              </svg>

            </div>
          }
          <div
            className="ranking-tutor-avatar border-4 -mt-3"
            style={{
              border: rank <= 3 ? `12px solid ${borderColor}` : 'none',
            }}
          >
            {tutor ?
              <img
                src={tutor?.profileImage}
                alt={`${tutor.name} 프로필`}
                style={{
                  width: '100%',
                  objectFit: 'cover'
                }} />
              :
              <NullAvatar rank={rank}></NullAvatar>
            }
          </div>
        </div>

        {rank == 1 &&
          <>
            <h3 className="keduall-typography heading-h4-semibold-600 text-center ranking-tutor-item-name mt-3 ">
              {tutor?.name}
              <span className={`fi fi-${tutor?.nationality} flag ml-2`}></span>
            </h3>
            <h3 className="keduall-typography heading-h33-normal-400 text-center">
              {tutor && <span>{tutor.points.toLocaleString()}<LabelPoint props={props} /></span>}
            </h3>
          </>
        }

        {(rank >= 2 && rank <= 3) &&
          <>
            <h4 className="keduall-typography heading-h4-semibold-600 text-hcenter ranking-tutor-item-name mt-2 ">
              {tutor?.name}
              <span className={`fi fi-${tutor?.nationality} flag ml-2`}></span>
            </h4>
            <h6 className="keduall-typography heading-h6-normal-400 text-center">
              {tutor && <span>{tutor.points.toLocaleString()}<LabelPoint props={props} /></span>}
            </h6>
          </>
        }

        {(rank >= 4 && rank <= 10) &&
          <>
            <h5 className="keduall-typography heading-h5-semibold-600 text-center ranking-tutor-item-name mt-2 ">
              {tutor?.name}
              <span className={`fi fi-${tutor?.nationality} flag ml-2`}></span>
            </h5>
            <p className="keduall-typography text-14-normal-400 text-center">
              {tutor && <span>{tutor.points.toLocaleString()}<LabelPoint props={props} /></span>}
            </p>
          </>
        }
      </div>
    </div>
  );
}